import { Evaluacion } from '@/app/models/interface/evaluacion.model';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { EvaluacionService } from '../services/evaluacion.service';

export const evaluacionResolver: ResolveFn<Evaluacion> = (route, state) => {
  const service = inject(EvaluacionService);

  const id = route.paramMap.get('id');

  return service.findOne(id ? id : '');
};

export const evaluacionParticipantesResolver: ResolveFn<Evaluacion> = (
  route,
  state
) => {
  const auth = inject(AuthService);
  const service = inject(EvaluacionService);

  const id = route.paramMap.get('id');

  return from(auth.returnUserInfo()).pipe(
    switchMap((data) =>
      service.getUserEvaluacion(id ? id : '', data?.id_usuario ?? 0)
    )
  );
};
